import ImageGallery from "react-image-gallery";
import React from 'react'
import "react-image-gallery/styles/css/image-gallery.css";
import { host } from './script/variables';

const ImageContainer = (props) => {
 
  
  return (
    <div style={{marginLeft:'auto',marginRight:'auto'}}>
      <ImageGallery items={props.imageUrls} />
    </div>
  )
}

export default ImageContainer
